import CreationToolOutputType from 'creation/src/creation-tools/types/output-type'
import CreationToolWelcomeButton from 'creation/src/creation-tools/types/welcome-button'
import type { ElementType } from 'react'
import { ClipIcon, GifIcon, StickerIcon } from '@/app/icons/content-types'
import { ScissorsIcon } from '@/app/icons/creation'

/**
 * Replacements for the legacy CreationToolOutputType / CreationToolWelcomeButton
 * `icon()` methods, removed from the shared package in Task 3 (icon components
 * can't live in a non-React package). Mirrors the switch in
 * app/static/js/site/creation-tools/types/welcome-button.ts.
 */
export const outputTypeIcon = (type: CreationToolOutputType): ElementType => {
    switch (type) {
        case CreationToolOutputType.Sticker:
            return StickerIcon
        case CreationToolOutputType.Video:
            return ClipIcon
        default:
            return GifIcon
    }
}

export const welcomeButtonIcon = (button: CreationToolWelcomeButton): ElementType => {
    switch (button) {
        case CreationToolWelcomeButton.Sticker:
        case CreationToolWelcomeButton.UploadSticker:
            return StickerIcon
        case CreationToolWelcomeButton.UploadVideo:
            return ClipIcon
        case CreationToolWelcomeButton.SuperCut:
            return ScissorsIcon
        case CreationToolWelcomeButton.UploadAddMore:
            // Never produced by CreationTool.welcomeButtons() for any tool
            // today — that button belongs to the post-upload "add more
            // files" flow, which hasn't been ported yet. Falls back to the
            // GIF icon rather than a missing/wrong one; give it a real icon
            // when that flow lands.
            return GifIcon
        default:
            return GifIcon
    }
}
